import planConfigSlice, { NAMESPACE as PLAN_CONFIG_NAMESPACE } from '../planConfig/slice';
import bookingSlice, { NAMESPACE as BOOKING_NAMESPACE } from '../booking/slice';
import cancellationSlice, { NAMESPACE as CANCELLATION_NAMESPACE } from '../cancellation/slice';
import accountSlice, { NAMESPACE as ACCOUNT_NAMESPACE } from '../account/slice';
import socialtSlice, { NAMESPACE as SOCIAL_NAMESPACE } from '../social/slice';
import toastSlice, { NAMESPACE as TOAST_NAMESPACE } from '../toast/slice';

const rootReducer = {
  [PLAN_CONFIG_NAMESPACE]: planConfigSlice.reducer,
  [BOOKING_NAMESPACE]: bookingSlice.reducer,
  [CANCELLATION_NAMESPACE]: cancellationSlice.reducer,
  [ACCOUNT_NAMESPACE]: accountSlice.reducer,
  [SOCIAL_NAMESPACE]: socialtSlice.reducer,
  [TOAST_NAMESPACE]: toastSlice.reducer,
};

export default rootReducer;
